import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';
import  './Resources/Actions.css';

export default function Deletedeposit()
{
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [depdetail, setDepdetail] = useState([]);
    const [account,setAccount] = useState([]);
    const APP_NAME = process.env.REACT_APP_NAME;


    useEffect(() => 
    {

    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});
  
  
    },[])

    function depositdetail()
    {
        fetch(API_URL+"api/Dayclosing/GetDeposit?id="+document.getElementById("depositnum").value).then(res=>res.json())
        .then((data)=>{setDepdetail(data)});
    }

    function loadedetails()
    {   
        
        if (depdetail.length > 0)
        {
            document.getElementById("edate").value = depdetail[0].EntryDate.slice(0,10);
            document.getElementById("source").value = depdetail[0].Source;
            document.getElementById("amount").value = depdetail[0].DepositAmount;
        }

    }

    function deletedeposit()
    {

        const depositaccount = account.filter((e)=>{if(e.AccountID === 1){return e;}})
        const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
        

        fetch(API_URL+"api/Delete/DeleteDeposit?id="+document.getElementById("depositnum").value,{method:"PUT",body:null})
        .then(res=>res.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit-parseFloat(document.getElementById('amount').value)),{method:"PUT",body:null})
        .then(response => response.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+depositaccount[0].AccountID+"&amount="+(depositaccount[0].CurrentCredit - parseFloat(document.getElementById('amount').value)),{method:"PUT",body:null})
        .then(response => response.json())
        .then(()=>{});

        fetch(API_URL+"api/Ledger/DeleteAccountLedgerEntry?id="+depdetail[0].CommonID,{method:"PUT",body:null})
        .then(res=>res.json())
        .then(()=>{});

        showOKdialog();
    }

    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
        dialog.show();
    }

    return(
        <>
        <div className="reportheader"> 
            {APP_NAME}
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1,marginBottom:"20px"}}>Deposits</div>
        
        <div>
        <fieldset style={{marginBottom:"15px"}}>
                <label for ="depositnum" style={{ marginLeft: "0px" }}>Deposit ID</label>
                <input id ="depositnum" style={{ height: "30px", width: "40%", marginLeft: "10px" }} onChange={()=>{depositdetail()}}></input>
                <button type="button" className="fetchbutton" onClick={() => {loadedetails()}} >Search</button>
        </fieldset>
        <fieldset>
            <legend>Deposit Details</legend>
            <label for = "edate" >Entry Date</label><br/>
            <input id = "edate" type="date" style ={{marginLeft:"1px",width:"98.5%",height: "30px"}} readOnly></input><br/><br/>
            <label for = "source" >Source</label><br/>
            <input id = "source" style ={{marginLeft:"1px",height: "30px",width:"98%"}}></input><br/><br/>
            <label for = "amount" >Deposit Amount</label><br/>
            <input id = "amount" style ={{marginLeft:"1px",height: "30px",width:"98%"}}></input>
        </fieldset>
        </div>
        
        <div style ={{marginTop:"70px"}}>
        <button type = "button"  className='actionbuttons' onClick={()=>{deletedeposit()}}>Delete</button> 
        <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/changes')}}>Cancel</button>
        </div>
        <dialog id="myDialog" className="okdialog"><p>Deposit Deleted Successful</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/changes');}}>OK</button>
      </dialog>
        </>
    )
}